<h3 class="mode-title">Embed this Gallery</h3>
@if (gallery.public_access === 'no_access' || (gallery.tenant || state.activeTenant)['block_public_link_access']) {
  <div class="rounded-banner warn">
    <app-svg src="/assets/icons/globe-disabled.svg"></app-svg>
    <span>Link access is disabled.</span>
    <button
      appButton
      name="enable-access"
      location="share-gallery-embed"
      color="warn"
      shape="round"
      height="1"
      (click)="onChangeMode.emit('link')"
    >
      Manage
    </button>
  </div>
}

<div
  class="main-container"
  [class.disabled]="
    gallery.public_access === 'no_access' || (gallery.tenant || state.activeTenant)['block_public_link_access']
  "
>
  <div class="fake-textarea">
    {{ embedCode }}
  </div>
  <div class="embed-footer">
    <app-context-menu [options]="{ width: '240px', noSpacing: true }" verticalPosition="top" #colorPickerMenu>
      <div contextContent>
        <app-color-picker [(color)]="newOptions.lightboxColor" [allowOpacity]="true" (colorChange)="onEmbedChange()">
        </app-color-picker>
      </div>
    </app-context-menu>
    <app-context-menu [options]="{ width: '260px', noSpacing: true }">
      <button
        appButton
        name="embed-settings"
        location="share-gallery-embed"
        color="simple"
        weight="bold"
        [hasIcon]="true"
        contextButton
      >
        <app-svg src="/assets/icons/code-circle.svg"></app-svg>
        <span>Embed Settings</span>
        <app-svg src="/assets/icons/chevron-down.svg" size="0"></app-svg>
      </button>
      <div contextContent>
        <div class="embed-settings-box">
          <label for="option-lightbox" class="embed-option">
            <div>Media Lightbox</div>
            <app-switch [small]="true">
              <input
                type="checkbox"
                id="option-lightbox"
                [(ngModel)]="newOptions.lightbox"
                (ngModelChange)="onEmbedChange()"
                appClickTrack
                name="lightbox"
                location="share-gallery-embed"
                [extra]="{ value: newOptions.lightbox }"
              />
              <label for="option-lightbox" data-test-id="option-lightbox"></label>
            </app-switch>
          </label>

          @if (newOptions.lightbox) {
            <button
              appButton
              name="lightbox-color"
              spacing="1"
              fullWidth="true"
              location="share-gallery-embed"
              (click)="colorPickerMenu.open()"
              color="simple"
              class="lightbox-color"
            >
              <span>Lightbox Color</span>
              <img src="/assets/rainbow-circle.png" alt="" />
            </button>
          }
          <label for="option-cover" class="embed-option">
            <div>Show Cover</div>
            <app-switch [small]="true">
              <input
                type="checkbox"
                id="option-cover"
                [(ngModel)]="newOptions.showCover"
                (ngModelChange)="onEmbedChange()"
                appClickTrack
                name="show-cover"
                location="share-gallery-embed"
                [extra]="{ value: newOptions.showCover }"
              />
              <label for="option-cover" data-test-id="option-cover"></label>
            </app-switch>
          </label>
          <label for="option-padding" class="embed-option">
            <div>Remove Padding</div>
            <app-switch [small]="true">
              <input
                type="checkbox"
                id="option-padding"
                [(ngModel)]="newOptions.noPadding"
                (ngModelChange)="onEmbedChange()"
                appClickTrack
                name="remove-padding"
                location="share-gallery-embed"
                [extra]="{ value: newOptions.noPadding }"
              />
              <label for="option-padding" data-test-id="option-padding"></label>
            </app-switch>
          </label>
          <label for="option-background" class="embed-option">
            <div>Remove Background</div>
            <app-switch [small]="true">
              <input
                type="checkbox"
                id="option-background"
                [(ngModel)]="newOptions.noBackground"
                (ngModelChange)="onEmbedChange()"
                appClickTrack
                name="remove-background"
                location="share-gallery-embed"
                [extra]="{ value: newOptions.noBackground }"
              />
              <label for="option-background" data-test-id="option-background"></label>
            </app-switch>
          </label>
        </div>

        <div class="divider"></div>

        <div class="embed-settings-box">
          @if (newOptions.lightbox) {
            <label for="option-downloads" class="embed-option">
              <div>Allow Downloads</div>
              @if ('gallery:download-from-embed' | billingScope) {
                <app-switch [small]="true">
                  @if (!gallery.download_single_asset) {
                    <!--Disabled-->
                    <input disabled type="checkbox" />
                  } @else {
                    <!--Enabled-->
                    <input
                      type="checkbox"
                      id="option-downloads"
                      [(ngModel)]="newOptions.allowDownloads"
                      (ngModelChange)="onEmbedChange()"
                      appClickTrack
                      name="allow-downloads"
                      location="share-gallery-embed"
                      [extra]="{ value: newOptions.allowDownloads }"
                    />
                  }
                  <label for="option-downloads" data-test-id="option-downloads"></label>
                </app-switch>
              } @else {
                <app-upgrade-badge
                  location="share-gallery-embed"
                  scope="gallery:download-from-embed"
                ></app-upgrade-badge>
              }
            </label>
          }

          <label for="option-right-click-protect" class="embed-option">
            <div>Right-Click Protect</div>
            @if ('asset:embed-right-click-protection' | billingScope) {
              <app-switch [small]="true">
                <input
                  type="checkbox"
                  id="option-right-click-protect"
                  [(ngModel)]="newOptions.rightClickProtection"
                  (ngModelChange)="onEmbedChange()"
                  appClickTrack
                  name="right-click-protection"
                  location="share-gallery-embed"
                  [extra]="{ value: newOptions.rightClickProtection }"
                />
                <label for="option-right-click-protect" data-test-id="option-right-click-protect"></label>
              </app-switch>
            } @else {
              <app-upgrade-badge
                location="share-gallery-embed"
                scope="asset:embed-right-click-protection"
              ></app-upgrade-badge>
            }
          </label>
        </div>
      </div>
    </app-context-menu>
    <div class="spacer"></div>
    <button
      appButton
      name="copy-embed"
      location="share-gallery-embed"
      color="primary"
      [share]="embedCode"
      (onCopied)="onCopy()"
      height="3"
      shape="round"
      size="3"
      weight="bold"
      spacing="4"
      [class.disabled]="
        gallery.public_access === 'no_access' || (gallery.tenant || state.activeTenant)['block_public_link_access']
      "
    >
      Copy
    </button>
  </div>
</div>
